import { get } from "lodash";

// Map basic page from new backend format
const mapBackendBasicPage = (data) => {
  if (!data) return null;

  // Handle both uppercase and lowercase field names
  const title = data.name || data.Name || data.title || data.Title || "";
  const content = data.body || data.Body || data.content || data.Content || "";
  const alias =
    data.urlAlias || data.UrlAlias || data.alias || data.Alias || "";
  const scrollspyVisible = data.scrollspyVisible || data.ScrollspyVisible;
  const createdAt =
    data.created || data.Created || data.createdAt || data.CreatedAt;
  const author = data.author || data.Author || data.creatorId || data.CreatorId;
  const imageUrl = data.imageUrl || data.ImageUrl;
  const pdfUrl = data.pdfUrl || data.PdfUrl;

  return {
    title,
    alias,
    image: imageUrl ? { url: imageUrl } : null,
    html: content,
    driveId: null, // Not supported in new backend yet
    fieldScrollspyVisible: scrollspyVisible,
    author,
    created: createdAt,
    pdf: pdfUrl,
  };
};

export const mapBasicPage = (page) => {
  if (!page) return;

  // Check if this is from the new backend (has a data property with the payload)
  if (page.data && !Array.isArray(page.data)) {
    return mapBackendBasicPage(page.data);
  }

  // Otherwise, use the old format mapping
  const { field_author, created } = page;

  return {
    title: get(page, "title[0].value"),
    alias: get(page, "path[0].alias"),
    image: get(page, "field_image[0]"),
    html: get(page, "body[0].processed"),
    driveId: get(page, "field_google_drive_id[0].value"),
    fieldScrollspyVisible: get(page, "field_scrollspy_visible[0].value"),
    author: field_author,
    created: created,
    pdf: get(page, "field_pdf[0].url"),
  };
};
